import { combineReducers } from "redux";
import {
  MANIFEST_GET_LOADING,
  MANIFEST_GET_ERROR,
  MANIFEST_GET_SUCCESS,
  MANIFEST_VIEW_LOADING,
  MANIFEST_VIEW_ERROR,
  MANIFEST_VIEW_SUCCESS,
  EMPTY_CONTAINER,
  MANIFEST_EXPORT_ERROR,
  MANIFEST_EXPORT_LOADING,
  MANIFEST_EXPORT_SUCCESS,
} from "../actions/constant";

// nico
const emptyContainer = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case EMPTY_CONTAINER:
      return { isLoad: action.isLoad, val: action.val };
    default:
      return state;
  }
};

const manifestGetLoading = (state = false, action) => {
  switch (action.type) {
    case MANIFEST_GET_LOADING:
      return action.manifestGetLoading;
    default:
      return state;
  }
};

const manifestGetError = (state = false, action) => {
  switch (action.type) {
    case MANIFEST_GET_ERROR:
      return action.manifestGetError;
    default:
      return state;
  }
};

const manifestGetSuccess = (state = false, action) => {
  switch (action.type) {
    case MANIFEST_GET_SUCCESS:
      return action.manifestGetSuccess;
    default:
      return state;
  }
};

const manifests = (state = [], action) => {
  switch (action.type) {
    case MANIFEST_GET_SUCCESS:
      return action.manifests;
    default:
      return state;
  }
};

const manifestViewLoading = (state = false, action) => {
  switch (action.type) {
    case MANIFEST_VIEW_LOADING:
      return action.manifestViewLoading;
    default:
      return state;
  }
};

const manifestViewError = (state = false, action) => {
  switch (action.type) {
    case MANIFEST_VIEW_ERROR:
      return action.manifestViewError;
    default:
      return state;
  }
};

const manifestViewSuccess = (state = false, action) => {
  switch (action.type) {
    case MANIFEST_VIEW_SUCCESS:
      return action.manifestViewSuccess;
    default:
      return state;
  }
};

const manifest = (state = [], action) => {
  switch (action.type) {
    case MANIFEST_VIEW_SUCCESS:
      return action.manifest;
    default:
      return state;
  }
};

// const manifestExportLoading = (state = false, action) => {
//   switch (action.type) {
//     case MANIFEST_EXPORT_LOADING:
//       return action.manifestExportLoading;
//     default:
//       return state;
//   }
// };

// const manifestExportError = (state = false, action) => {
//   switch (action.type) {
//     case MANIFEST_EXPORT_ERROR:
//       return action.manifestExportError;
//     default:
//       return state;
//   }
// };

// const manifestExportSuccess = (state = false, action) => {
//   switch (action.type) {
//     case MANIFEST_EXPORT_SUCCESS:
//       return action.manifestExportSuccess;
//     default:
//       state;
//   }
// };

// const manifesting = (state = [], action) => {
//   switch (action.type) {
//     case MANIFEST_EXPORT_SUCCESS:
//       return action.manifesting;
//     default:
//       state;
//   }
// };

const manifestReducer = combineReducers({
  manifestGetLoading,
  manifestGetError,
  manifestGetSuccess,
  manifests,

  manifestViewLoading,
  manifestViewError,
  manifestViewSuccess,
  manifest,
  emptyContainer,

  // manifestExportLoading,
  // manifestExportError,
  // manifestExportSuccess,
  // manifesting,
});

export default manifestReducer;
